"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRedirectUrls = getRedirectUrls;
exports.getSplititObj = getSplititObj;
exports.splititConfigIsValid = splititConfigIsValid;
exports.initSplitit = initSplitit;
exports.splititSessionStorageKey = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _genericValidation = require("../global/utils/genericValidation");

var _loggers = require("../global/utils/loggers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var splititSessionStorageKey = 'splititData'; // 50 mins

exports.splititSessionStorageKey = splititSessionStorageKey;
var splititTimeout = 3000000;
var additionalSessionStorageKeys = ['timeRetrievedFromServer', 'originalTransactionId', 'originalRequestbody'];

function getRedirectUrls() {
  var _window, _window$location, _window2, _window2$location, _window3, _window3$location;

  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname;
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.search;
  var currUrl = ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$location = _window3.location) === null || _window3$location === void 0 ? void 0 : _window3$location.origin) + path;
  return {
    succeeded: "".concat(currUrl, "/succeeded").concat(queryParams),
    failed: "".concat(currUrl, "/failed").concat(queryParams),
    canceled: "".concat(currUrl, "/canceled").concat(queryParams)
  };
} // Example obj
// {
//     transactionId: 'sr_jI0QLfyqgK4eK4pDY',
//     practiceId: 'aad35040-1068-11ea-9229-d148159416a2',
//     amount: '2004.00',
//     RedirectUrls: {
//         Succeeded: 'https://example.com/success',
//         Canceled: 'https://example.com/cancel',
//         Failed: 'https://example.com/fail',
//     },
//     ConsumerData: {
//         CultureName: 'en-us',
//         FullName: 'Ron Burgundy',
//         PhoneNumber: '5551239876',
//         Email: 'emasi+splititTest@vitusvet.com',
//     },
//     PaymentWizardData: {
//         IsOpenedInIframe: false,
//     },
//     PlanData: {
//         NumberOfInstallments: 0,
//         AutoCapture: true,
//         ExtendedParams: {
//            invoice_id: "I'm in a glass case of emotion",
//            staff_member: 'Trogdor the Burninator',
//         },
//         RefOrderNumber: 'sr_jI0QLfyqgK4eK4pDY',
//     },
// };


function getSplititObj(args) {
  var transactionId = args.transactionId,
      practiceId = args.practiceId,
      practiceName = args.practiceName,
      amount = args.amount,
      redirectUrls = args.redirectUrls,
      _args$fullName = args.fullName,
      fullName = _args$fullName === void 0 ? '' : _args$fullName,
      _args$phoneNumber = args.phoneNumber,
      phoneNumber = _args$phoneNumber === void 0 ? '' : _args$phoneNumber,
      _args$email = args.email,
      email = _args$email === void 0 ? '' : _args$email,
      _args$invoiceId = args.invoiceId,
      invoiceId = _args$invoiceId === void 0 ? '' : _args$invoiceId,
      _args$staffMember = args.staffMember,
      staffMember = _args$staffMember === void 0 ? '' : _args$staffMember;
  var obj = {
    transactionId: transactionId,
    practiceId: practiceId,
    amount: amount,
    RedirectUrls: {
      Succeeded: redirectUrls.succeeded,
      Canceled: redirectUrls.canceled,
      Failed: redirectUrls.failed
    },
    ConsumerData: {
      CultureName: 'en-us',
      FullName: fullName,
      PhoneNumber: phoneNumber,
      Email: email
    },
    PaymentWizardData: {
      IsOpenedInIframe: false
    },
    PlanData: {
      NumberOfInstallments: 0,
      AutoCapture: true,
      ExtendedParams: {
        invoice_id: invoiceId,
        staff_member: staffMember,
        originalTransactionId: transactionId
      },
      RefOrderNumber: "".concat(practiceName, "(").concat(practiceId, ")")
    }
  };
  return obj;
}

function splititConfigIsValid(config) {
  var _config$redirectUrls = config.redirectUrls,
      redirectUrls = _config$redirectUrls === void 0 ? {} : _config$redirectUrls;
  var basicDetails = ['transactionId', 'practiceId', 'practiceName', 'amount', 'splititInitUrl'];
  var hasBasicDetails = basicDetails.every(function (val) {
    return (0, _genericValidation.isNonEmptyString)(config[val]);
  });
  var redirectUrlProps = ['succeeded', 'failed', 'canceled'];
  var hasRedirectUrls = redirectUrlProps.every(function (val) {
    return (0, _genericValidation.isNonEmptyString)(redirectUrls[val]);
  });
  if (hasBasicDetails && hasRedirectUrls) return true;
  return false;
}

function savedDataIsValid(args) {
  var savedData = args.savedData,
      splititConfig = args.splititConfig;

  try {
    var _parsed$timeRetrieved;

    var parsed = JSON.parse(savedData);
    var fields = [].concat(additionalSessionStorageKeys, ['CheckoutUrl']);
    var hasFields = fields.every(function (f) {
      return f in parsed;
    }); // Splitit checkout urls are only valid for 1 hour (by default)
    // Check if the data in session storage is too old

    var now = Date.now();
    var offset = now - ((_parsed$timeRetrieved = parsed === null || parsed === void 0 ? void 0 : parsed.timeRetrievedFromServer) !== null && _parsed$timeRetrieved !== void 0 ? _parsed$timeRetrieved : -Infinity);
    var timestampIsValid = offset < splititTimeout;
    var checkoutUrlIsString = (0, _genericValidation.isNonEmptyString)(parsed === null || parsed === void 0 ? void 0 : parsed.CheckoutUrl);
    var idIsValid = (splititConfig === null || splititConfig === void 0 ? void 0 : splititConfig.transactionId) === (parsed === null || parsed === void 0 ? void 0 : parsed.originalTransactionId); // If a new valid config is passed we want to use the new config

    var isSameConfig = splititConfigIsValid(splititConfig) && (parsed === null || parsed === void 0 ? void 0 : parsed.originalRequestbody) === JSON.stringify(getSplititObj(splititConfig));
    return hasFields && timestampIsValid && checkoutUrlIsString && idIsValid && isSameConfig;
  } catch (err) {
    return false;
  }
}

function getSplititDataFromSessionStorage(splititConfig) {
  var _window4, _window4$sessionStora;

  var savedData = (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$sessionStora = _window4.sessionStorage) === null || _window4$sessionStora === void 0 ? void 0 : _window4$sessionStora.getItem(splititSessionStorageKey);
  var isValid = savedData ? savedDataIsValid({
    savedData: savedData,
    splititConfig: splititConfig
  }) : false;

  if (savedData && isValid) {
    var parsed = JSON.parse(savedData);
    additionalSessionStorageKeys.forEach(function (f) {
      if (parsed[f]) delete parsed[f];
    });
    return parsed;
  }

  return null;
}

function requestInitSplititFromServer(_x) {
  return _requestInitSplititFromServer.apply(this, arguments);
}

function _requestInitSplititFromServer() {
  _requestInitSplititFromServer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(splititConfig) {
    var splititInitUrl, _ref, _res$data$data, _res$data, _window5, _window5$sessionStora, body, res, data, checkoutUrlIsString, saveToSessionStorage;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            splititInitUrl = splititConfig.splititInitUrl;
            _context.prev = 1;
            body = getSplititObj(splititConfig);
            _context.next = 5;
            return _axios.default.post(splititInitUrl, body);

          case 5:
            res = _context.sent;

            if (!((res === null || res === void 0 ? void 0 : res.status) ? (res === null || res === void 0 ? void 0 : res.status) !== 200 : false)) {
              _context.next = 8;
              break;
            }

            throw new Error('Could not get data from server');

          case 8:
            data = (_ref = (_res$data$data = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) !== null && _res$data$data !== void 0 ? _res$data$data : res === null || res === void 0 ? void 0 : res.data) !== null && _ref !== void 0 ? _ref : res;
            checkoutUrlIsString = (0, _genericValidation.isNonEmptyString)(data === null || data === void 0 ? void 0 : data.CheckoutUrl);

            if (checkoutUrlIsString) {
              _context.next = 12;
              break;
            }

            throw new Error('Data returned from server was not expected format');

          case 12:
            saveToSessionStorage = _objectSpread(_objectSpread({}, data), {}, {
              originalTransactionId: splititConfig.transactionId,
              timeRetrievedFromServer: Date.now(),
              originalRequestbody: JSON.stringify(body)
            });
            (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$sessionStora = _window5.sessionStorage) === null || _window5$sessionStora === void 0 ? void 0 : _window5$sessionStora.setItem(splititSessionStorageKey, JSON.stringify(saveToSessionStorage));
            return _context.abrupt("return", data);

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", _context.t0);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 17]]);
  }));
  return _requestInitSplititFromServer.apply(this, arguments);
}

function initSplitit(_x2) {
  return _initSplitit.apply(this, arguments);
} // const exampleResponse = {
//   data: {
//     CheckoutUrl:
//       'https://checkout.sandbox.splitit.com/v2.0?token=8fc926a1-1e9c-44dd-ab44-4de1405d0f19&culture=en-US',
//     ApprovalUrl: '',
//     TermsAndConditionsUrl:
//       'https://documents.sandbox.splitit.com/TermsAndConditions/?PublicToken=8fc926a1-1e9c-44dd-ab44-4de1405d0f19',
//     PrivacyPolicyUrl:
//       'https://documents.sandbox.splitit.com/PrivacyPolicy/?PublicToken=8fc926a1-1e9c-44dd-ab44-4de1405d0f19',
//     InstallmentPlanInfoUrl:
//       'https://landing.sandbox.splitit.com/en-US/InstallmentPlan/ShowAgreement/?PublicToken=8fc926a1-1e9c-44dd-ab44-4de1405d0f19',
//     PublicToken: '8fc926a1-1e9c-44dd-ab44-4de1405d0f19',
//     LearnMoreUrl:
//       'https://documents.sandbox.splitit.com/LearnMore/?PublicToken=8fc926a1-1e9c-44dd-ab44-4de1405d0f19',
//     ResponseHeader: {
//       Succeeded: true,
//       Errors: [],
//       TraceId: '0HM51RLKQN7JF:00000002#LjCCuZNXO0AAA',
//     },
//     InstallmentPlan: {
//       InstallmentPlanNumber: '51382618325381366032',
//       InstallmentPlanStatus: {
//         Code: 'Initializing',
//         Id: 11,
//         Description: 'Initializing',
//       },
//       Amount: {
//         Value: 1995,
//         Currency: {
//           Symbol: 'US$',
//           Id: 1,
//           Code: 'USD',
//           Description: 'US Dollar',
//         },
//       },
//       OutstandingAmount: {
//         Value: 1995,
//         Currency: {
//           Symbol: 'US$',
//           Id: 1,
//           Code: 'USD',
//           Description: 'US Dollar',
//         },
//       },
//       NumberOfInstallments: 0,
//       NumberOfProcessedInstallments: 0,
//       OriginalAmount: {
//         Value: 1995,
//         Currency: {
//           Symbol: 'US$',
//           Id: 1,
//           Code: 'USD',
//           Description: 'US Dollar',
//         },
//       },
//       RefundAmount: {
//         Value: 0,
//         Currency: {
//           Symbol: 'US$',
//           Id: 1,
//           Code: 'USD',
//           Description: 'US Dollar',
//         },
//       },
//       Consumer: {
//         Id: '0',
//         UserName: 'emasispl',
//         FullName: 'Ron Burgundy',
//         Email: 'emasi+splititTest@vitusvet.com',
//         PhoneNumber: '5551239876',
//         CultureName: 'en-US',
//         RoleName: null,
//         IsLocked: false,
//         IsDataRestricted: false,
//       },
//       ActiveCard: null,
//       FraudCheck: null,
//       Terminal: {
//         Id: 30708,
//         Code: '30561',
//         Description: 'VitusVetAPI',
//       },
//       Merchant: {
//         Name: 'VitusVet',
//         Id: 30561,
//         Code: 'vitusvet',
//         Description: 'VitusVet',
//       },
//       RefOrderNumber: 'practiceName(practiceId)',
//       PurchaseMethod: {
//         Code: 'ECommerce',
//         Id: 3,
//         Description: 'E-Commerce',
//       },
//       Strategy: {
//         Code: 'SecuredPlan',
//         Id: 1,
//         Description: 'Secured',
//       },
//       DelayResolution: null,
//       ExtendedParams: {
//         invoice_id: "I'm in a glass case of emotion",
//         staff_member: 'Trogdor the Burninator',
//         practiceId: 'aad35040-1068-11ea-9229-d148159416a2',
//         practiceName: 'Irving Dev Practice',
//         applicationFeePercentage: '3',
//         applicationFee: '59.85',
//         userId: '',
//       },
//       IsFullCaptured: false,
//       IsChargedBack: false,
//       ArePaymentsOnHold: false,
//       ScpFundingPercent: 0,
//       IsFunded: false,
//       TestMode: 'None',
//       CreationDateTime: '2020-12-17T15:05:37.7126098Z',
//       Installments: null,
//       SecureAuthorizations: null,
//       LogoUrl: null,
//     },
//   },
//   success: true,
// };


function _initSplitit() {
  _initSplitit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(splititConfig) {
    var splititLoadingStartHandler, configIsValid, savedData, res;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            splititLoadingStartHandler = splititConfig.splititLoadingStartHandler;
            (0, _loggers.localLogger)('%cInitializing splitit', 'color: palegoldenrod');
            configIsValid = splititConfigIsValid(splititConfig);

            if (configIsValid) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", splititConfig);

          case 5:
            if ((0, _genericValidation.isFunction)(splititLoadingStartHandler)) splititLoadingStartHandler();
            savedData = getSplititDataFromSessionStorage(splititConfig);

            if (!savedData) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", savedData);

          case 9:
            _context2.next = 11;
            return requestInitSplititFromServer(splititConfig);

          case 11:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _initSplitit.apply(this, arguments);
}